module.exports = __webpack_public_path__ + "media/es_slide26_sweep_fresadora.d5573efb.mp4";